import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import React, { Children } from 'react';
import { branch, mapProps } from 'recompose';
import types from 'prop-types';
import { styled, StyleSheet } from '@rexlabs/styling';
var hintStyles = StyleSheet({
  container: {
    color: 'grey',
    fontStyle: 'normal',
    fontSize: '0.9rem',
    paddingTop: '0.25rem',
    cursor: 'inherit'
  }
});

var Hint = function Hint(_ref) {
  var text = _ref.text,
      styles = _ref.styles;
  return React.createElement("div", styles('container'), text);
};

Hint.displayName = 'Hint';
var HintStyled = styled(hintStyles)(Hint);
var withHint = mapProps(function (_ref2) {
  var hint = _ref2.hint,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["hint", "children"]);

  return _objectSpread({}, props, {
    children: [].concat(_toConsumableArray(Children.toArray(children)), [React.createElement(HintStyled, {
      text: hint,
      key: hint
    })])
  });
});
var withoutHint = mapProps(function (_ref3) {
  var hint = _ref3.hint,
      props = _objectWithoutProperties(_ref3, ["hint"]);

  return props;
});
export default branch(function (_ref4) {
  var hint = _ref4.hint;
  return !!hint;
}, withHint, withoutHint);
export var propTypes = {
  hint: types.string
};